import { io } from 'socket.io-client';

var socket = null;

function getSocket() {
  if (socket && socket.connected) return socket;
  var token = localStorage.getItem('autodoc_token') || '';
  if (!token) return null;
  // Phase 2: REACT_APP_API_BASE 우선 (도메인 분리 후 api.autodex.kr 로 WebSocket 연결)
  var _envBase = (process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '');
  var _runtimeBase = process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:4000';
  var url = _envBase || _runtimeBase;
  try {
    socket = io(url, {
      auth: { token: token },
      transports: ['websocket', 'polling'],
      reconnectionAttempts: 5,
      reconnectionDelay: 3000
    });
    socket.on('connect_error', function() {});
  } catch(e) {
    socket = null;
  }
  return socket;
}

function disconnectSocket() {
  if (socket) {
    try { socket.disconnect(); } catch(e) {}
    socket = null;
  }
}

export { getSocket, disconnectSocket };
